import CirklonObject from '../custom/CirklonObject';
import {doc} from './docs.js';

doc(
    "cirklon",
    {
    },
    "Cirklon sequencer interface",
    () => 0,
    {
        inlets: 0
    });

export const cirklon = (object) => {
    object.effect = new CirklonObject(object);
    return () => {
    };
};
